import { useQuery } from '@apollo/client';
import React, { useContext, useState } from 'react';
import { CompanyContext } from '../../../../../context/CompanyContext';
import {
  GetVentoryApiKeyResponse,
  GetVentoryApiKeyVariables,
  VentoryApiQueries,
  GenerateVentoryApiKeyResponse,
  GenerateVentoryApiKeyVariables,
  VentoryApiMutations,
} from '../../../../../graphql/api.graphql';
import useMutation from '../../../../../hooks/useMutation';
import { useToast } from '../../../../../providers/ToastProvider';
import { TranslationKey } from '../../../../../types/translation/TranslationKey';
import { translate } from '../../../../../types/translation/Translator';
import { Button } from '../../../../components/Button';
import { Surface } from '../../../../components/Surface';
import { TextInput } from '../../../../components/TextInput';
import { ToastType } from '../../../../components/Toast';
import { Icon } from '../../../../icons';
import { IconType } from '../../../../icons/Icon';

export default function DeveloperSettingsView() {
  const { showToast } = useToast();

  const { currentCompany } = useContext(CompanyContext);

  const [visible, setVisible] = useState<boolean>(false);
  const [key, setKey] = useState<string>('');

  const { loading: loadingGet } = useQuery<GetVentoryApiKeyResponse, GetVentoryApiKeyVariables>(VentoryApiQueries.get, {
    variables: {
      companyId: currentCompany.id,
    },
    onCompleted: res => {
      setKey(res.ventoryApiKey?.key || '');
    },
    onError: err => showToast({ type: ToastType.error, title: err.message }),
  });

  const [generate, { loading: loadingGenerate }] = useMutation<
    GenerateVentoryApiKeyResponse,
    GenerateVentoryApiKeyVariables
  >(VentoryApiMutations.generate, {
    variables: {
      companyId: currentCompany.id,
    },
    onCompleted: res => {
      setKey(res.generateApiKey.key);
      setVisible(true);
    },
  });

  return (
    <Surface>
      <div className='grid gap-4'>
        <p className='section-title'>{translate({ key: TranslationKey.developerOptions })}</p>
        <TextInput
          label={'Company ID'}
          disabled={true}
          value={currentCompany.id}
          trailing={
            <Icon
              type={IconType.copy02}
              onClick={() => {
                navigator.clipboard.writeText(currentCompany.id);
                showToast({ type: ToastType.success, title: translate({ key: TranslationKey.copiedToClipboard }) });
              }}
            />
          }
        />
        <TextInput
          label={translate({ key: TranslationKey.apiKey })}
          placeholder={translate({ key: TranslationKey.generateApiKey })}
          disabled
          value={visible ? key : '*******************'}
          onChange={() => {}}
          trailing={<Icon type={IconType.eye} onClick={() => setVisible(!visible)} />}
        />
        <Button
          className='w-fit'
          disabled={loadingGet}
          loading={loadingGenerate}
          onClick={() => generate()}
          text={translate({ key: TranslationKey.generateApiKey })}
        />
      </div>
    </Surface>
  );
}
